export class Encrypt {

    public static async sha1(str:string): Promise<string> {
        const hashBuffer = await crypto.subtle.digest('SHA-1',new TextEncoder().encode(str))
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(e => e.toString(16).padStart(2, '0')).join('')
    }
}